// extracted by mini-css-extract-plugin
module.exports = {"hotspotComponentWrapper":"wT","slider-wrapper":"wU"};